import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
// import { DashboardSidebar } from "~/features/dashboard/components/dashboard-sidebar";

// import { DashboardHeader } from "~/features/dashboard/components/header";
// import { urgentCareNavigationItems } from "~/features/dashboard/data/navigation";

function UrgentCareLayout() {
  return (
    <section
      className="flex w-full flex-col justify-center"
      role="region"
      aria-labelledby="urgent-care-heading"
    >
      {/* <DashboardHeader items={urgentCareNavigationItems} title="Urgent Care" /> */}

      {/* <DashboardSidebar /> */}
      <div className="container flex-grow">
        <Outlet />
      </div>
    </section>
  );
}

export const Route = createFileRoute("/(dashboard)/dashboard/urgent-care")({
  beforeLoad: () => {
    throw redirect({
      to: "/dashboard/weight-loss",
    });
    // if (!context.auth.user || !context.auth.user.program?.includes("urgent_care")) {
    //   throw redirect({
    //     to: '/dashboard/weight-loss',
    //   })
    // }
  },
  component: UrgentCareLayout,
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-4">
      <h2 className="text-xl font-bold">Error Loading Urgent Care</h2>
      <pre className="mt-4">{error.message}</pre>
    </div>
  ),
});
